import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionDetails, AccordionSummary, FormControlLabel, styled } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import Checkbox from "@mui/material/Checkbox";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import each from "lodash/each";
import get from "lodash/get";
import React from "react";
import { us_states_map } from "../utils/constants";
import { marketFilters } from "./constants";

// Styled Components
const MenuSectionTitle = styled("h4")`
    color: #9e9e9e;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: 5px;
`;

const StyledAccordion = styled(Accordion)`
    margin: 0;
    border-top: 1px solid #eeeeee;
`;

const StyledAccordionSummary = styled(AccordionSummary)`
    min-height: 0 !important;
    &.Mui-expanded {
        margin: 0 !important;
        background: #fafafa;
    }
    .MuiAccordionSummary-content {
        margin: 0;
        .Mui-expanded {
            margin: 0 !important;
            background: #fafafa;
        }
    }
`;

const StyledAccordionDetails = styled(AccordionDetails)({
    padding: "0 20px",
    borderTop: "1px solid #eeeeee",
});

const GridItemCheckbox = styled(Grid)({
    "&.MuiGrid-item": {
        padding: "8px",
    },
    width: "100%",
});

const MarketFilters = (props) => {
    const {
        handleSelectMarket,
        handleSelectMicromarket,
        handleSelectSubmarket,
        marketFilterExpansionPanels,
        searchCriteria,
        toggleMarketFilterExpansionPanel,
    } = props;

    const countMarketSubmarketsSelected = (searchCriteria, path) => {
        let count = 0;
        each(Object.keys(get(searchCriteria, `locationCriteria.markets.${path}`, {})), (key) => {
            if (get(searchCriteria, `locationCriteria.markets.${path}.${key}.selected`, false) === true) {
                count += 1;
            }
        });
        return count;
    };

    return (
        <Grid container>
            <Grid container>
                {Object.keys(marketFilters).map((stateCode) => {
                    return (
                        <React.Fragment key={stateCode}>
                            <FormLabel
                                component="legend"
                                style={{ marginBottom: "10px", paddingLeft: "20px", paddingTop: "10px" }}
                            >
                                {us_states_map[stateCode]}
                            </FormLabel>
                            {Object.keys(marketFilters[stateCode]).map((market) => {
                                return (
                                    <Grid
                                        item
                                        xs
                                        sx={{ flexGrow: 1, flexBasis: "100%", maxWidth: "100%", minWidth: "Auto" }}
                                        key={market}
                                    >
                                        <StyledAccordion expanded={get(marketFilterExpansionPanels, market, false)}>
                                            <StyledAccordionSummary
                                                expandIcon={
                                                    <ExpandMoreIcon
                                                        onClick={() => {
                                                            toggleMarketFilterExpansionPanel(market);
                                                        }}
                                                    />
                                                }
                                            >
                                                <Grid container>
                                                    <Grid item>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={get(
                                                                        searchCriteria,
                                                                        `locationCriteria.markets.${market}.selected`,
                                                                        false
                                                                    )}
                                                                    onChange={(e) =>
                                                                        handleSelectMarket(market, e.target.checked)
                                                                    }
                                                                    value={market}
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={`${market} ${
                                                                countMarketSubmarketsSelected(searchCriteria, market) >
                                                                0
                                                                    ? `(${countMarketSubmarketsSelected(
                                                                          searchCriteria,
                                                                          market
                                                                      )})`
                                                                    : ""
                                                            }`}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </StyledAccordionSummary>
                                            <StyledAccordionDetails>
                                                <Grid container>
                                                    <GridItemCheckbox item xs={12}>
                                                        <MenuSectionTitle>{market} Submarkets</MenuSectionTitle>
                                                    </GridItemCheckbox>
                                                    {Object.keys(marketFilters[stateCode][market]).map((submarket) => {
                                                        if (marketFilters[stateCode][market][submarket].length > 0) {
                                                            return (
                                                                <Grid item xs={12} key={submarket}>
                                                                    <StyledAccordion
                                                                        expanded={get(
                                                                            marketFilterExpansionPanels,
                                                                            `${market}.${submarket}`,
                                                                            false
                                                                        )}
                                                                    >
                                                                        <StyledAccordionSummary
                                                                            expandIcon={
                                                                                marketFilters[stateCode][market][
                                                                                    submarket
                                                                                ].length > 0 ? (
                                                                                    <ExpandMoreIcon
                                                                                        onClick={() => {
                                                                                            toggleMarketFilterExpansionPanel(
                                                                                                `${market}.${submarket}`
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    ""
                                                                                )
                                                                            }
                                                                        >
                                                                            <Grid container>
                                                                                <Grid item>
                                                                                    <FormControlLabel
                                                                                        control={
                                                                                            <Checkbox
                                                                                                checked={get(
                                                                                                    searchCriteria,
                                                                                                    `locationCriteria.markets.${market}.${submarket}.selected`,
                                                                                                    false
                                                                                                )}
                                                                                                onChange={(e) =>
                                                                                                    handleSelectSubmarket(
                                                                                                        market,
                                                                                                        submarket,
                                                                                                        e.target.checked
                                                                                                    )
                                                                                                }
                                                                                                value={submarket}
                                                                                                color="primary"
                                                                                            />
                                                                                        }
                                                                                        label={`${submarket} ${
                                                                                            countMarketSubmarketsSelected(
                                                                                                searchCriteria,
                                                                                                `${market}.${submarket}`
                                                                                            ) > 0
                                                                                                ? `(${countMarketSubmarketsSelected(
                                                                                                      searchCriteria,
                                                                                                      `${market}.${submarket}`
                                                                                                  )})`
                                                                                                : ""
                                                                                        }`}
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        </StyledAccordionSummary>
                                                                        <StyledAccordionDetails>
                                                                            <Grid container>
                                                                                <GridItemCheckbox item xs={12}>
                                                                                    <MenuSectionTitle>
                                                                                        {market} - {submarket}{" "}
                                                                                        Micromarkets
                                                                                    </MenuSectionTitle>
                                                                                </GridItemCheckbox>
                                                                                {marketFilters[stateCode][market][
                                                                                    submarket
                                                                                ].map((micromarket) => {
                                                                                    return (
                                                                                        <GridItemCheckbox
                                                                                            item
                                                                                            xs={6}
                                                                                            key={micromarket}
                                                                                            sx={{
                                                                                                flexGrow: 0,
                                                                                                flexBasis: "50%",
                                                                                                maxWidth: "50%",
                                                                                                minWidth: "0",
                                                                                            }}
                                                                                        >
                                                                                            <FormControlLabel
                                                                                                control={
                                                                                                    <Checkbox
                                                                                                        checked={get(
                                                                                                            searchCriteria,
                                                                                                            `locationCriteria.markets.${market}.${submarket}.${micromarket}.selected`,
                                                                                                            false
                                                                                                        )}
                                                                                                        onChange={(e) =>
                                                                                                            handleSelectMicromarket(
                                                                                                                market,
                                                                                                                submarket,
                                                                                                                micromarket,
                                                                                                                e.target
                                                                                                                    .checked
                                                                                                            )
                                                                                                        }
                                                                                                        value={
                                                                                                            micromarket
                                                                                                        }
                                                                                                        color="primary"
                                                                                                    />
                                                                                                }
                                                                                                label={micromarket}
                                                                                            />
                                                                                        </GridItemCheckbox>
                                                                                    );
                                                                                })}
                                                                            </Grid>
                                                                        </StyledAccordionDetails>
                                                                    </StyledAccordion>
                                                                </Grid>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </Grid>
                                            </StyledAccordionDetails>
                                        </StyledAccordion>
                                    </Grid>
                                );
                            })}
                        </React.Fragment>
                    );
                })}
            </Grid>
        </Grid>
    );
};

export default MarketFilters;
